export const WINDOW_DIMENSION_MOBILE = 521
export const WINDOW_DIMENSION_MOBILE_LG = 639
export const WINDOW_DIMENSION_TABLET = 768
